import { createRoot } from 'react-dom/client';

import { App } from 'shared/ui/App';

import bootstrap from './bootstrap';

bootstrap().then(() => {
    createRoot(document.getElementById('root')).render(<App />);
});
